export default {"src":"/_next/static/media/logo_text_only.75c2b226.svg","height":903,"width":2308,"blurWidth":0,"blurHeight":0};